export default "__VITE_ASSET__CmGCvQYG__"